import { initAllAnalytics } from '../utils/analytics';
import {useEffect } from 'react';
import { userUtils } from '../utils/auth';

export default function AppInitializer() {
  const user = userUtils.getUser();
  useEffect(() => {
    initAllAnalytics({
        userData: user ? {
            id: user.id,
            email: user.email,
            name: user.name,
        } : null,
    });
  }, []);

  return null; // renders nothing
}